(() => {
  if (!document.body?.classList.contains('template-index')) return;

  const main = document.querySelector('#MainContent');
  if (!main) return;

  const videoShell = main.querySelector('[data-video-background]');
  if (videoShell) {
    try {
      const options = JSON.parse(videoShell.getAttribute('data-options') || '{}');
      const type = String(options.type || '').trim();
      const videoId = String(options.vid || '').trim();
      if (!type && !videoId) {
        videoShell.removeAttribute('data-video-background');
        videoShell.querySelectorAll('[data-bgvideo-insert]').forEach((node) => node.remove());
      }
    } catch (_) {
      /* Leave vendor behavior alone if the section data is not parseable. */
    }
  }

  const hero = main.querySelector('.ftf-img-video.lazyloadftf[data-src]');
  if (!hero) return;

  const source = hero.dataset.src;
  if (!source) return;

  let widths = [];
  try {
    widths = JSON.parse(hero.dataset.widths || '[]')
      .map((value) => Number.parseInt(value, 10))
      .filter((value) => Number.isFinite(value) && value > 0);
  } catch (_) {}
  if (!widths.length) widths = [545, 745, 1000, 1400, 1800, 2000];

  const imageUrl = (width) => {
    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (_) {
      return source;
    }
  };

  hero.loading = 'eager';
  hero.fetchPriority = 'high';
  hero.sizes = '100vw';
  hero.srcset = widths.map((width) => `${imageUrl(width)} ${width}w`).join(', ');
  hero.src = imageUrl(widths.includes(1400) ? 1400 : widths[Math.floor(widths.length / 2)]);
  hero.classList.remove('lazyloadftf');
  hero.classList.add('lazyloaded');
  hero.removeAttribute('data-src');
  hero.removeAttribute('data-widths');
  hero.removeAttribute('data-sizes');
  hero.removeAttribute('data-optimumx');
})();
